<!-- 안전리더십 > 보고서 -->
<template>
  <Loading v-if="isLoading" />
  <div class="tabCont">
    <div class="content-inner-box">
      <div class="mo-info-group" v-if="utils.isMobile()">
        <div class="txt">{{t('message.pcOptimizedNotice')}}</div>
      </div>
      <div class="tit-group ty01">
        <h4 class="tit">{{leadershipData.leadershipTitle}}</h4>
        <div class="btn-group">
          <c-btn02 :btnText="t('message.download')" class="sm" @click="onClickDownload"/>
        </div>
      </div>
      <div class="form-group row-ty02">
        <!--form-row-->
        <div class="form-row" v-if="isReportAdmin || userInfo.roles != 'USER'">
          <div class="row">
            <InputSearch03 :placeholder="t('message.restrictedToAuthorizedViewers')" @confirm="confirmMember"></InputSearch03>

            <div class="sort-group ty03">
              <div class="sort-row">
                <div class="wl">
                  <div class="date-sort">
                    <c-InputDate v-model="startDate" :enableTimePicker="false" readonly="" />
                    <div class="txt02">~</div>
                    <c-InputDate v-model="endDate" :enableTimePicker="false" readonly=""/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row" v-else>
          <div class="txt-tit">{{t('message.basicInfo')}}</div>
          <div class="row">
            <div class="txt">{{ `${targetMember.memberName||t('message.noInfo')} / ${targetMember.posName||t('message.noInfo')} / ${targetMember.deptName||t('message.noInfo')}` }} </div>
            <div class="sort-group ty03">
              <div class="sort-row">
                <div class="wl">
                  <div class="date-sort">
                    <c-InputDate v-model="startDate" :enableTimePicker="false" readonly="" />
                    <div class="txt02">~</div>
                    <c-InputDate v-model="endDate" :enableTimePicker="false" readonly=""/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row" v-if="Object.keys(leadershipSummaryData).length > 0">
          <div class="txt-tit">{{t('message.summaryReport')}}</div>
          <div class="row">
            <div class="card-group02 ty01">
              <div class="card-col ty02">
                <div class="icon ico8" aria-hidden="true"></div>
                <div class="txt-group">
                  <div class="txt1">{{ Math.round(leadershipSummaryData.totalScore) }}<span>{{t('message.point')}}</span></div>
                  <div class="txt2">{{t('message.safetyLeadershipScore')}}</div>
                </div>
              </div>
              <div class="card-col ty04">
                <div class="icon ico9" aria-hidden="true"></div>
                <div class="txt-group">
                  <div class="inner">
                    <div class="txt1">
                      <span>전체</span>
                      <div>{{ leadershipSummaryData.totalCnt }}<span>{{t('message.count')}}</span></div>
                    </div>
                    <div class="inner-line"></div>
                    <div class="txt1">
                      <span>{{t('message.complete')}}</span>
                      <div>{{leadershipSummaryData.completeCnt}}<span>{{t('message.count')}}</span></div>
                    </div>
                    <div class="inner-line"></div>
                    <div class="txt1">
                      <span>{{t('message.completionRate')}}</span>
                      <div>{{ completePercent }}<span>%</span></div>
                    </div>
                  </div>
                  <div class="txt2">{{t('message.taskStatus')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row page2-inner1" v-if="Object.keys(leadershipSummaryData).length > 0">
          <div class="txt-tit sb">
            {{t('message.taskProgressDetails')}}
            <div class="txt-info02">
              <i class="ico-point"></i>
              {{t('message.performanceReflectionItems')}}
            </div>
          </div>
          <div class="mo-ty" v-if="false">
            <c-btn01 :btnText="t('message.downloadDetailedProgress')" @click="DialogSLRResultModel=true"/>
          </div>
          <div class="row mo-ty">
            <div class="tbl-group line-ty size-custom11">
              <v-data-table
                :headers="headers"
                :items="leadershipContentList"
                hide-default-footer
                disable-sort
                return-object
              >
                <template v-slot:item="{ item }">
                  <tr class="v-data-table__tr">
                    <td :rowspan="item.task_cnt" v-if="item.task_cnt>0">
                      <div class="txt-group" v-html="item.taskTitle"></div>
                    </td>
                    <td :rowspan="item.task_cnt" v-if="item.task_cnt>0">
                      <div class="txt-group flex-c">{{item.taskEvaluationRatio}}%</div>
                    </td>
                    <td>
                      <div class="txt-group" v-html="item.contentTitle??''"></div>
                    </td>
                    <td>
                      <div class="txt-group flex-c">{{periodText(item)}}</div>
                    </td>
                    <td>
                      <div class="txt-group flex-c">{{item.evaluationRatio}}%</div>
                    </td>
                    <td>
                      <div class="txt-group flex-c">
                        <span v-if="item.contentType=='1' || item.contentType=='2'">{{resultText(item)}}</span>
                        <div v-if="item.contentType=='3' || item.contentType=='4'">
                          <c-tooltip02 :btnText="resultText(item)" :TooltipText="item.tooltipText"/>
                        </div>
                      </div>
                    </td>
                    <td v-if="false">
                      <div class="txt-group flex-c" v-if="item.fileCnt > 0">
                        <BtnIcon class="btn-ico-result" @click="onClickFileListPopup(item)"/>
                      </div>
                    </td>
                  </tr>
                </template>
                <template
                  v-slot:tfoot
                >
                  <tfoot class="ty01">
                    <tr>
                      <td>{{t('message.totalScore2')}}</td>
                      <td colspan="4"></td>
                      <td>{{t('message.overall')}} <span>{{ Math.round(leadershipSummaryData.totalScore) }}</span></td>
                      <td></td>
                    </tr>
                  </tfoot>

                </template>
              </v-data-table>
            </div>
          </div>
        </div>
        <!--form-row 20250525 모니터링 결과 상세 추가-->
        <div class="form-row" v-if="myAnswerList.length > 0">
          <div class="txt-tit">
            {{t('message.mySafetyLeadershipMonitoringDetails')}}
          </div>
          <div class="row scrollbar">
            <div class="tbl-group line-ty tbl-fixed size-custom21">
              <v-table>
                <thead>
                <tr>
                  <th colspan="2">{{t('message.categoryLS')}}</th>
                  <th rowspan="2">{{t('message.compositeScore')}}</th>
                  <th v-for="period in periodList" :key="period" colspan="4">{{ period }}{{t('message.sessionNumber')}}</th>
                </tr>
                <tr>
                  <th>{{t('message.categoryType')}}</th>
                  <th>{{t('message.monitoringBehavior')}}</th>
                  <template v-for="period in periodList" :key="period">
                    <th colspan="2">{{t('message.selfScore')}}</th>
                    <th colspan="2">{{t('message.othersScore')}}</th>
                  </template>
                </tr>
                </thead>
                <tbody>
                <template v-for="(categoryGroup, categoryIdx) in groupedByCategory(myAnswerList)" :key="categoryIdx">
                  <template v-for="(behaviorGroup, behaviorIdx) in categoryGroup.behaviors" :key="behaviorIdx">
                  <tr>
                    <!-- 카테고리 rowspan -->
                    <td v-if="behaviorIdx === 0" :rowspan="categoryGroup.behaviors.length">
                      <div class="td-size1">{{ categoryGroup.categoryTitle }}</div>
                    </td>
                    <!-- 모니터링행동 -->
                    <td><div class="td-size2">{{ behaviorGroup.behaviorTitle }}</div></td>
                    <!-- 종합점수 -->
                    <td v-if="behaviorIdx === 0" :rowspan="categoryGroup.behaviors.length">
                      {{ getCategoryAverageScore(categoryGroup.behaviors) }}
                    </td>
                    <!-- 회차별 우측반복 -->
                    <template v-for="(period, i) in periodList" :key="period">
                      <td :class="{ 'highlight-td': i % 2 === 0 }">{{ getScore(behaviorGroup.entries, period, 3) }}</td>
                      <td :class="{ 'highlight-td': i % 2 === 0 }" v-if="behaviorIdx === 0" :rowspan="categoryGroup.behaviors.length">
                        {{ getCategoryPeriodContentTypeAverage(categoryGroup.behaviors, period, 3) }}
                      </td>
                      <td :class="{ 'highlight-td': i % 2 === 0 }">{{ getScore(behaviorGroup.entries, period, 4) }}</td>
                      <td :class="{ 'highlight-td': i % 2 === 0 }" v-if="behaviorIdx === 0" :rowspan="categoryGroup.behaviors.length">
                        {{ getCategoryPeriodContentTypeAverage(categoryGroup.behaviors, period, 4) }}
                      </td>
                    </template>
                  </tr>
                  </template>
                </template>
                </tbody>
              </v-table>
            </div>
          </div>
        </div>
        <div class="form-row" v-if="deptAnswerList.length > 0 && userInfo.roles != 'USER'">
          <div class="txt-tit">
            {{t('message.organizationSafetyLeadershipMonitoringDetails')}}
          </div>
          <div class="row scrollbar">
            <div class="tbl-group line-ty tbl-fixed">
              <v-table>
                <thead>
                <tr>
                  <th colspan="2">{{t('message.categoryLS')}}</th>
                  <th colspan="2">{{t('message.adminOverallAverage')}}</th>
                  <th v-for="dept in deptList" :key="dept.deptIdx" colspan="2">{{ dept.deptName }}</th>
                </tr>
                <tr>
                  <th>{{t('message.categoryType')}}</th>
                  <th>{{t('message.monitoringBehavior')}}</th>
                  <th colspan="">{{t('message.selfScore')}}</th>
                  <th colspan="">{{t('message.othersScore')}}</th>
                  <template v-for="dept in deptList" :key="dept.deptIdx">
                    <th colspan="">{{t('message.selfScore')}}</th>
                    <th colspan="">{{t('message.othersScore')}}</th>
                  </template>
                </tr>
                </thead>
                <tbody>
                <template v-for="(categoryGroup, categoryIdx) in groupedByCategory(deptAnswerList)" :key="categoryIdx">
                  <template v-for="(behaviorGroup, behaviorIdx) in categoryGroup.behaviors" :key="behaviorIdx">
                  <tr>
                    <td v-if="behaviorIdx === 0" :rowspan="categoryGroup.behaviors.length">
                      <div class="td-size1">{{ categoryGroup.categoryTitle }}</div>
                    </td>
                    <!-- 소분류 -->
                    <td><div class="td-size2">{{ behaviorGroup.behaviorTitle }}</div></td>
                    <!-- 관리자 전체 평균 -->
                    <td>{{ getAverageScore(behaviorGroup.entries, 3) }}</td>
                    <td>{{ getAverageScore(behaviorGroup.entries, 4) }}</td>
                    <!-- 부서별 점수 -->
                    <template v-for="(dept, i) in deptList" :key="dept.deptIdx">
                      <td :class="{ 'highlight-td': i % 2 === 0 }">{{ getDeptBehaviorScore(behaviorGroup.entries, dept.deptIdx, 3) }}</td>
                      <td :class="{ 'highlight-td': i % 2 === 0 }">{{ getDeptBehaviorScore(behaviorGroup.entries, dept.deptIdx, 4) }}</td>
                    </template>
                  </tr>
                  </template>
                </template>
                </tbody>
              </v-table>
            </div>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row" v-if="Object.keys(leadershipSummaryData).length > 0">
          <div class="txt-tit">
            {{t('message.interviewNotes')}}
            <span class="txt-info">
              {{t('message.interviewVisibilityNote')}}
            </span>
          </div>
          <div class="row">
            <Textarea v-model="leadershipData.interviewContent" :disabled="!isReportAdmin"></Textarea>
          </div>
        </div>
      </div>

      <div class="bottom-btn-group ty01 page2-inner2" v-if="Object.keys(leadershipSummaryData).length > 0 && isReportAdmin">
        <div class="wl"></div>
        <div class="wr">
          <c-btn01 :btnText="t('message.registerInterviewNotes')" @click="onClickInterview"/>
        </div>
      </div>
    </div>
  </div>
  <!-- 잘못만듬 -->
  <DialogSLRResult v-model="DialogSLRResultModel"
            @close="DialogSLRResultModel=false"
  />
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>

  <!--popup: 결과물 보기-->
  <DialogDetailView
    v-model="DialogDetailViewModel"
    @close="DialogDetailViewModel=false"
  />

</template>

<script setup lang="ts">
import {ref, onMounted, watch} from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import LeadershipService from "@/services/leadership.service";
import utils from "@/common/Utils";
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import dayjs from "dayjs";
const { t } = useI18n();
import { useDisplay } from 'vuetify'
const { mobile } = useDisplay()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//define
const props = defineProps({isActive: Boolean})

//bind
const isLoading = ref<boolean>(false)
const snackbar = ref(false)
const snackText = ref('')
let viewIdx = route.params.idx!='null'?route.params.idx:''
const leadershipData:any = ref({})
const targetMember:any = ref({})
const leadershipSummaryData:any = ref({})
const DialogSLRResultModel = ref(false)
const leadershipContentList = ref([])
const isReportAdmin:any = ref(false)
const myAnswerList = ref([])
const deptAnswerList = ref([])
const userInfo = JSON.parse(localStorage.getItem('user'))
const startDate = ref(dayjs().startOf('month').format('YYYY-MM-DD'))
const endDate = ref(dayjs().endOf('month').format('YYYY-MM-DD'))
const DialogDetailViewModel = ref(false)

//ui
const headers = ref([
  { title: t('message.taskName'), key: 'title' },
  { title: t('message.taskWeight'), key: 'title' },
  { title: t('message.subTaskName'), key: 'titleDetail' },
  { title: t('message.periodLeadership'), key: 'period'},
  { title: t('message.subTaskWeight'), key: 'importance' },
  { title: t('message.result'), key: 'result' },
  //{ title: t('message.viewDeliverables'), key: 'resultView' },
])

//hook
onMounted(() => {
})

//computed
const completePercent = computed(()=>{
  if(!utils.isEmpty(leadershipSummaryData.value.completeCnt) && !utils.isEmpty(leadershipSummaryData.value.totalCnt))
    return Math.round(leadershipSummaryData.value.completeCnt / leadershipSummaryData.value.totalCnt * 100)
  else
    return 0
})

const periodText = computed(()=>(item) => {
  const type = item.periodType;
  let result = ''
  if (type >= 1 && type <= 6) result = t('message.week')
  if (type === 11) result = t('message.quarter')
  if (type === 12) result = t('message.halfYear')
  if (type === 13) result = t('message.year3')

  return result+item.periodCnt+t('message.countUnit')
})

const resultText = computed(()=>(item:any) => {
  const type = item.contentType;
  let result = ''
  if(item.taskReportYn == 'Y' && item.reportYn == 'Y' && item.evaluationRatio > 0 && item.taskEvaluationRatio > 0) {
    result = Math.round(item.weightedScore) + ''
    /*
    if (item.contentType == '1' && !utils.isEmpty(item.weightedScore))
      result = item.weightedScore + ''
    else if (item.contentType == '2' && !utils.isEmpty(item.weightedScore))
      result = item.weightedScore + ''
    else if ((item.contentType == '3' || item.contentType == '4') && !utils.isEmpty(item.weightedScore))
      result = item.weightedScore + ''
     */
  }
  else{
      result = t('message.notApplicable')
  }

  return result
})

//function
const getLeadership=async()=>{
  let params = {
    idx: viewIdx
  }

  try{
    const response = await LeadershipService.getLeadership(params)
    if (response.success) {
      leadershipData.value = response.result
      storeRef.leadershipInfo.value = response.result
    } else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const getLeadershipSummary=async(memberIdx)=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    companyIdx:companyIdx,
    memberIdx:memberIdx,
    leadershipIdx:viewIdx,
    startDate:startDate.value,
    endDate:endDate.value
  }
  try{
    isLoading.value = true
    const response = await LeadershipService.getLeadershipSummary(params)
    isLoading.value = false
    leadershipSummaryData.value = response.result
    //회차별로 분리된 항목을 contentidx 끼리 묶음
    if(utils.isEmpty(leadershipSummaryData.value.leadershipList))
      return
    const groupedList = _(leadershipSummaryData.value.leadershipList[0].leadershipContentList)
      .groupBy(item => item.mergeYn === 'Y' && item.parentIdx !== 0 ? item.parentIdx : item.idx)
      .map((items, key) => {
      // 첫 번째 항목을 기준으로 복사
      const base = { ...items[0] }
      // weightedScore 합계
      base.weightedScore = _.sumBy(items, 'weightedScore')
      base.selfAnswerCnt = _.sumBy(items, 'selfAnswerCnt')
      base.otherAnswerCnt = _.sumBy(items, 'otherAnswerCnt')
      base.fileCnt = _.sumBy(items, 'fileCnt')
      if(base.taskReportYn == 'Y')
        base.taskTitle += '<i class="ico-point"></i>'
      if(base.reportYn == 'Y')
        base.contentTitle += '<i class="ico-point"></i>'
      if(base.selfAnswerCnt > 0 || base.otherAnswerCnt > 0 )
        base.tooltipText = `${t('message.selfMonitoring')}:${base.selfAnswerCnt} <br/> ${t('message.peerMonitoring')}:${base.otherAnswerCnt}`
      return base
    }).value()
    //content_idx수정됐을경우 taskIdx기준으로 다시 소팅
    const sortedList = _.orderBy(groupedList,['taskIdx', 'idx'], ['asc', 'asc'])
    //첫번째 task에 content갯수 탑재
    const taskCountMap = _.countBy(sortedList, 'taskIdx')
    const taskSeen = {}
    const processedList = sortedList.map(item => {
      const taskIdx = item.taskIdx
      const task_cnt = taskSeen[taskIdx] ? 0 : taskCountMap[taskIdx]
      taskSeen[taskIdx] = true
      return {
        ...item,
        task_cnt
      }
    })
    leadershipContentList.value = processedList
  }
  catch(error){
    isLoading.value = false
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const getMonitoringSummary=async(memberIdx)=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    companyIdx:companyIdx,
    leadershipIdx:viewIdx,
    memberIdx:memberIdx,
    startDate:startDate.value,
    endDate:endDate.value
  }
  try{
    const response = await LeadershipService.getLeadershipMonitoringSummary(params)
    myAnswerList.value = response.result.myAnswerList
    deptAnswerList.value = response.result.deptAnswerList
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const confirmMember=async(item)=>{
  targetMember.value = item
  await getLeadershipSummary(item.idx)
  await getMonitoringSummary(item.idx)
}

//컨텐츠 파일리스트
const onClickFileListPopup=async(item)=>{
  let params = {
    contentIdx:item.idx,
    memberIdx:targetMember.value.idx??targetMember.value.memberIdx  //팝업idx와 localstorage idx가 다름
  }
  try{
    const response = await LeadershipService.getLeadershipFBFileList(params)
    storeRef.fileList.value = response.result
    DialogDetailViewModel.value = true
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const onClickDownloadFile=async(item)=>{
  let params = {
    contentIdx:item.idx,
    memberIdx:targetMember.value.idx??targetMember.value.memberIdx  //팝업idx와 localstorage idx가 다름
  }
  try{
    const response = await LeadershipService.getLeadershipFileDownload(params)
    const blob:any = response
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'files.zip';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const onClickInterview=async()=>{
  let params = {
    idx: leadershipData.value.idx,
    interviewContent: leadershipData.value.interviewContent
  }

  try{
    const response = await LeadershipService.insertLeadershipInterview(params)
    if (response.success) {
      snackText.value = t('message.savedSuccessfully')
      snackbar.value = true
    } else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

// periodList별 정렬 리스트 추출
const periodList = computed(() => {
  return _.uniq(myAnswerList.value.map(i => i.periodSeq)).sort((a, b) => a - b)
})

// 부서별 정렬 리스트 추출
const deptList = computed(() => {
  const depts = _.uniqBy(deptAnswerList.value, 'deptIdx')
  return depts.sort((a, b) => a.deptIdx - b.deptIdx)
})

// category + behavior별 그룹핑
const groupedByCategory = computed(()=>(list) => {
  return _(list)
    .groupBy('categoryTitle')
    .map((items, categoryTitle) => ({
      categoryTitle,
      behaviors: _(items)
        .groupBy('behaviorTitle')
        .map((entries, behaviorTitle) => ({
          behaviorTitle,
          entries
        }))
        .value()
    }))
    .value()
})


// behavior별 특정 월 + contentType 점수
const getScore = (entries, periodSeq, contentType) => {
  const match = entries.find(e =>
    e.periodSeq === periodSeq && e.contentType === contentType
  )
  return (!match || ['5','6'].includes(match.behaviorType))
    ? '-'
    : Number(match.answerScore).toFixed(1)
}

// 종합점수: behavior 평균
const getBehaviorAverageScore = (entries, targetContentType = null) => {
  const filtered = targetContentType
    ? entries.filter(e => e.contentType === targetContentType)
    : entries

  const scores = filtered
    .filter(e => !['5','6'].includes(e.behaviorType))   // 5,6 제외
    .map(e => parseFloat(e.answerScore))
    .filter(v => !isNaN(v))

  if (!scores.length) return '-'

  const sum = scores.reduce((a, b) => a + b, 0)
  const avg = sum / scores.length

  return avg.toFixed(1)
}

const getCategoryAverageScore = (behaviorGroups, targetContentType = null) => {
  const allEntries = behaviorGroups.flatMap(b => b.entries)
  return getBehaviorAverageScore(allEntries, targetContentType)
}

// 카테고리별 contentType 월합계
const getCategoryPeriodContentTypeAverage = (behaviorGroups, periodSeq, contentType) => {
  const allEntries = behaviorGroups.flatMap(g => g.entries)
  const scores = allEntries
    .filter(e => !['5','6'].includes(e.behaviorType))   // 5,6 제외
    .filter(e => e.periodSeq === periodSeq && e.contentType === contentType)
    .map(e => parseFloat(e.answerScore || 0))
  const validScores = scores.filter(s => !isNaN(s))
  return validScores.length ? (validScores.reduce((a, b) => a + b, 0) / validScores.length).toFixed(1) : '-'
}

//부서별 전체통계
const getAverageScore = (entries, contentType) => {
  const filtered = entries.filter(e => e.contentType === contentType)
  if (filtered.length === 0) return '-'
  const total = filtered.reduce((sum, e) => sum + Number(e.answerScore), 0)
  return (total / filtered.length).toFixed(1)
}

//부서별점수
const getDeptBehaviorScore = (entries, deptIdx, contentType) => {
  const filtered = entries.filter(e =>
    Number(e.deptIdx) === Number(deptIdx) &&
    Number(e.contentType) === Number(contentType)
  )
  if (filtered.length === 0) return '-'
  const total = filtered.reduce((sum, e) => sum + Number(e.answerScore), 0)
  return (total / filtered.length).toFixed(1)
}

//다운로드
const onClickDownload = async()=>{
  await nextTick(); // Vue에서 DOM 그려진 후 실행

  const element = document.querySelector('.page2') as HTMLElement;
  if (!element) return;

  const canvas = await html2canvas(element, {
    useCORS: true,
    scale: 2,
    allowTaint: true,
  });

  const imgData = canvas.toDataURL('image/png');

  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4',
  });

  const pageWidth = pdf.internal.pageSize.getWidth();  // 210mm
  const pageHeight = pdf.internal.pageSize.getHeight(); // 297mm

  // px to mm 비율 계산
  const pxPerMm = canvas.width / pageWidth;

  // 실제 이미지의 크기(mm 기준)
  const imgHeightMm = canvas.height / pxPerMm;

  let remainingHeight = imgHeightMm;
  let position = 0;

  // 한 페이지에 그릴 이미지 높이(px 기준)
  const pageHeightPx = pageHeight * pxPerMm;

  while (remainingHeight > 0) {
    const canvasPage = document.createElement('canvas');
    canvasPage.width = canvas.width;
    canvasPage.height = Math.min(pageHeightPx, canvas.height - position);

    const ctx = canvasPage.getContext('2d');
    if (ctx) {
      ctx.drawImage(
        canvas,
        0, position,                        // Source X, Y
        canvas.width, canvasPage.height,   // Source Width, Height
        0, 0,                               // Dest X, Y
        canvas.width, canvasPage.height    // Dest Width, Height
      );

      const pageImgData = canvasPage.toDataURL('image/png');
      pdf.addImage(pageImgData, 'PNG', 0, 0, pageWidth, canvasPage.height / pxPerMm);
    }

    remainingHeight -= pageHeight;
    position += pageHeightPx;

    if (remainingHeight > 0) {
      pdf.addPage();
    }
  }

  pdf.save('leadershipTotalSummary.pdf');
}

//watch
watch(() => props.isActive, async (val, oldVal) => {
  if (val) {
    /*
    if(utils.isMobile()){   //if(mobile.value){
      snackText.value = t('message.pcOptimizedNotice')
      snackbar.value = true
    }
     */
    await getLeadership()
    targetMember.value = userInfo
    isReportAdmin.value = _.some((storeRef.leadershipInfo.value as any).reportTargets, {idx: userInfo.memberIdx})
    await getLeadershipSummary(userInfo.memberIdx)
    await getMonitoringSummary(userInfo.memberIdx)
  }
},{ immediate: true })

//watch
watch(startDate, async (newObj) => {
  if(props.isActive) {
    await getLeadershipSummary(targetMember.value?.idx??userInfo.memberIdx)
    await getMonitoringSummary(targetMember.value?.idx??userInfo.memberIdx)
  }
})
watch(endDate, async (newObj) => {
  if(props.isActive){
    await getLeadershipSummary(targetMember.value?.idx??userInfo.memberIdx)
    await getMonitoringSummary(targetMember.value?.idx??userInfo.memberIdx)
  }
})
</script>


<style lang="scss" >
</style>
